<template>
  <div>
    <div style="font-size: 14px; color: #606266" class="mb-2">
      <span style="font-size: 14px; color: #606266"
        >Bill No：{{ formData.stockReturnNo }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>Status：{{ formData.billStatusName }}</span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Create：{{ formData.createByName }} at
        {{ formData.createDate }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyByName }} at
        {{ formData.modifyDate }}
      </span>
    </div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_sales') || '外借销售'"
            prop="useSalesCode"
          >
            <dict-select
              clearable
              v-model="formData.useSalesCode"
              filterable
              size="small"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_business_person') ||
                  '请选择业务人员'
              "
              :selectedLabel.sync="formData.useSalesName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_customer') || '收货客户'"
            prop="useCustCode"
          >
            <dict-select
              clearable
              v-model="formData.useCustCode"
              filterable
              url="/master/common/dict/customerSelect"
              :placeholder="$l('tips_select_customer') || '请选择客户'"
              style="width:100%"
              :selectedLabel.sync="formData.useCustName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_factory') || '收货工厂'"
            prop="useFactoryCode"
          >
            <dict-select
              clearable
              size="small"
              filterable
              v-model="formData.useFactoryCode"
              :placeholder="$l('tips_select_factory') || '请输入收货工厂'"
              url="/master/common/dict/scmCooperated"
              :selectedLabel.sync="formData.useFactoryName"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_borrow_date') || '外借日期'"
            prop="borrowDate"
          >
            <el-date-picker
              style="width:100%"
              size="small"
              v-model="formData.borrowDate"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="
                $l('INDEX.form_label_please_select_the_loan_date') ||
                  '选择外借日期'
              "
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_use_place') || '使用地点'"
            prop="usePlace"
          >
            <dict-select
              :placeholder="$l('tips_select_use_place') || '请输入使用地点'"
              size="small"
              clearable
              filterable
              v-model="formData.usePlace"
              :body="usePlaceParams"
              url="/master/common/dict/biz"
              :selectedLabel.sync="formData.usePlaceName"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    formData: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      backDialogVisible: false,
      usePlaceParams: { dictType: 'usePlace' },
      rules: {
        useSalesCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_a_salesperson') ||
              '请选择销售人员',
            trigger: 'change',
          },
        ],
        usePlace: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_a_place_to_use') ||
              '请选择使用地点',
            trigger: 'change',
          },
        ],
        borrowDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_the_loan_date') ||
              '请选择外借日期',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {
    async getFormData() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )
        return
      }
      return this.formData
    },
  },
}
</script>
